import React from 'react';
import PropTypes from 'prop-types';
import Select2 from "shared/react_components/Select2/index";
import FieldError from "./FieldError";

export default class AffiliateSelect extends React.Component {
  render() {
    const { errorMessages, nameLabel } = this.props;
    const fieldErrors = errorMessages.map((error) => <FieldError errorMessage={error} key={error} />);
    const validationClass = fieldErrors.length > 0 ? "sb-field-group--invalid" : "";

    return (
      <div className={`sb-field-group ${validationClass}`} data-affiliate-campaign-selector-row="true" data-mount="affiliate_campaign_id">
        <label className="sb-field-label">{nameLabel}</label>
        <div data-selector="affiliate-campaign-select">
          <Select2 {...this.selectArgs()} />
        </div>
        {fieldErrors}
      </div>
    );
  }

  selectArgs() {
    const { friendlyNameField, uniqueNameField, destinationCampaign, allowSearch, values, changeListener } = this.props;

    return {
      friendlyNameField,
      uniqueNameField,
      allowSearch,
      values,
      changeListener,
      url:    destinationCampaign.affiliateCampaignUrl,
      node:   destinationCampaign,
      width:  "400px"
    };
  }

  static propTypes = {
    nameLabel:            PropTypes.string.isRequired,
    urlParams:            PropTypes.object,
    urlBase:              PropTypes.string,
    friendlyNameField:    PropTypes.string,
    uniqueNameField:      PropTypes.string,
    allowSearch:          PropTypes.bool,
    values:               PropTypes.array,
    destinationCampaign:  PropTypes.object,
    changeListener:       PropTypes.func,
    errorMessages:        PropTypes.array
  };

  static defaultProps = {
    friendlyNameField:  "text",
    uniqueNameField:    "0",
    allowSearch:        true,
    values:             [],
    errorMessages:      []
  };
}
